
// Componente SVG de WhatsApp separado
const WhatsAppIcon = () => (
    <svg
        width="36"
        height="36"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="whatsapp-icon"
    >
        <path
            d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.485 3.485"
            fill="currentColor"
        />
    </svg>
);

// Componente SVG de Teléfono
const PhoneIcon = () => (
    <svg
        width="36"
        height="36"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="phone-icon"
    >
        <path
            d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="currentColor"
        />
    </svg>
);

// Componente SVG de Email
const EmailIcon = () => (
    <svg
        width="36"
        height="36"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="email-icon"
    >
        <path
            d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <polyline
            points="22,6 12,13 2,6"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default function DatosContacto({ frase }) {
    const contactOptions = [
        {
            icon: 'phone',
            label: 'Teléfono',
            value: '228 366 7786',
            link: 'tel:228 366 7786',
            renderIcon: () => <PhoneIcon />
        },
        {
            icon: 'whatsapp',
            label: 'Whatsapp',
            value: '+52 228 366 7786',
            link: 'https://wa.me/+522283667786',
            renderIcon: () => <WhatsAppIcon />
        },
        {
            icon: 'email',
            label: 'Email',
            value: 'ventas_orsan@hotmail.com',
            link: 'mailto:ventas_orsan@hotmail.com',
            renderIcon: () => <EmailIcon />
        },
    ];

    return (
        <div className="contacto-container">
            {/* Sección de contacto directo mejorada */}
            <section className="contacto" aria-labelledby="contacto-heading">
                <header className="contacto-header">
                    <h2 id="contacto-heading">Contáctanos</h2>
                    <p className="contacto-subtitle">{frase}</p>
                    <div className="contacto-decoracion" aria-hidden="true">
                        <span className="decoracion-punto"></span>
                        <span className="decoracion-linea"></span>
                        <span className="decoracion-punto"></span>
                    </div>
                </header>
                
                <div className="contacto-opciones" role="list">
                    {contactOptions.map(({ label, value, link, renderIcon }, index) => (
                        <article 
                            key={label}
                            className="contacto-opcion"
                            style={{ animationDelay: `${index * 0.2}s` }}
                            role="listitem"
                        >
                            <a
                                href={link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="contacto-link"
                                aria-label={`Contactar por ${label}: ${value}`}
                            >
                                <div className="contacto-icon-wrapper">
                                    {renderIcon()}
                                    <span className="icon-pulse" aria-hidden="true"></span>
                                </div>
                                <div className="contacto-info">
                                    <h3 className="contacto-label">{label}</h3>
                                    <p className="contacto-value">{value}</p>
                                </div>
                                <div className="contacto-arrow" aria-hidden="true">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                        <path 
                                            d="M7 17L17 7M17 7H7M17 7V17" 
                                            stroke="currentColor" 
                                            strokeWidth="2" 
                                            strokeLinecap="round" 
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                            </a>
                        </article>
                    ))}
                </div>
                
                <footer className="contacto-footer">
                    <p className="contacto-cta">
                        <span className="cta-icon">💬</span>
                        Estamos aquí para ayudarte con todas tus necesidades inmobiliarias
                    </p>
                </footer>
            </section>
        </div>
    );
}